export class CookieHelper {
  private hostBase: string;

  public constructor(hostBase: string) {
    this.hostBase = hostBase;

  }
  public CreateCookie(name: string, value: string, days: number): void {
    let expires: string;
    if (days > 0) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    else {
      expires = "";
    }

    if (window.location.hostname === "localhost") {
      document.cookie = `${name}=${value}${expires}; path=/`;
    } else {
      const isSecure = window.location.protocol === 'https:';
      const secureFlag = isSecure ? '; Secure' : '';

      // Chrome rejects cookies with both domain=.parentdomain AND SameSite=Lax
      // when set from a subdomain. We try parent domain first (for cross-subdomain sharing),
      // then fall back to host-only cookie if that fails.

      // Try 1: Parent domain cookie (allows sharing across subdomains)
      // Note: We omit SameSite when setting cross-subdomain cookies because
      // Chrome rejects the combination of domain=.parent + SameSite=Lax from subdomains
      document.cookie = `${name}=${value}${expires}; domain=.${this.hostBase}; path=/${secureFlag}`;

      // Check if it worked
      if (!document.cookie.includes(name)) {
        // Try 2: Host-only cookie (fallback - won't be shared across subdomains)
        document.cookie = `${name}=${value}${expires}; path=/; SameSite=Lax${secureFlag}`;
      }
    }
  }

  public EraseCookie(name: string): void {
    // Must erase both domain variants since we don't know which one was set
    // Browser treats host-only cookies and domain cookies as separate cookies

    if (window.location.hostname === "localhost") {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    } else {
      const isSecure = window.location.protocol === 'https:';
      const secureFlag = isSecure ? '; Secure' : '';

      // Erase host-only cookie (no domain)
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${secureFlag}`;

      // Erase domain cookie (.gemell.io)
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=.${this.hostBase}; path=/${secureFlag}`;
    }
  }

  public ReadCookie(name: string): string | null {
    const nameEQ = name + "=";
    const cookieParts = document.cookie.split(';');

    for (let i = 0; i < cookieParts.length; i++) {
      let cookiePart = cookieParts[i];

      while (cookiePart.charAt(0) === ' ') {
        cookiePart = cookiePart.substring(1, cookiePart.length);
      }

      if (cookiePart.indexOf(nameEQ) === 0) {
        return cookiePart.substring(nameEQ.length, cookiePart.length);
      }
    }
    return null;
  }

  public IsLoggedIn(): boolean {
    const apiKey = this.ReadCookie("ApiKey");

    return (apiKey !== null)
      && (apiKey !== undefined)
      && (apiKey !== "")
      && (apiKey !== "undefined");
  }
}
